// src/components/SearchBar.jsx

import React from 'react';
import PropTypes from 'prop-types';
import './SearchBar.css';
import { useTranslation } from 'react-i18next';
import { useLanguageSettings } from '../Common/LanguageSettingsContext';
import { useColorSettings } from '../Common/ColorSettingsContext';
import Spinner from '../Common/Spinner';

const SearchBar = ({ searchTerm, onSearchChange }) => {
  const { t } = useTranslation();

  const { language, updateLanguage, loading: languageLoading } = useLanguageSettings();
  const { appSettings, loading: colorLoading } = useColorSettings();

  if (colorLoading || languageLoading) {
    return (
      <div className="search-bar-container">
        <Spinner />
      </div>
    );
  }

  return (
    <input
      type="text"
      placeholder={t('searchBar.placeholder')}
      className={`search-bar`}
      value={searchTerm}
      onChange={(e) => {
        onSearchChange(e);
      }}
      aria-label={t('searchBar.placeholder')}
    />
  );
};

SearchBar.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export default SearchBar;
